import { render, staticRenderFns } from "./MbMemory.vue?vue&type=template&id=0e3bfe5a&scoped=true&"
import script from "./MbMemory.vue?vue&type=script&lang=js&"
export * from "./MbMemory.vue?vue&type=script&lang=js&"
import style0 from "./MbMemory.vue?vue&type=style&index=0&id=0e3bfe5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3bfe5a",
  null
  
)

export default component.exports